<template>
    <div class="col-md-4 mt-2 mb-2 m-car">
        <div class="p-3 text-center border rounded border-main">
            <img class="img-responsive rounded-circle" :src="this.ProfileImage" width="90" :alt="'Photo of ' + this.Member.Name">
            <h2 class="mt-3 name">{{this.Member.Name}}</h2>
            <div class="work d-block">{{this.Member.Position}}</div>
            <div class="mt-4">
                <a class="v-profile" :href="getNewArticleURL(this.Member.MemberID, this.Member.DealerLocationID)" :aria-label="'View Profile of' + this.Member.Name">{{this.viewProfile}}</a>
            </div>
        </div>
    </div>
</template>
<script>
    import {viewProfile} from '../../constants/labels.config'
    export default {
        name: "MemberCard",
        props:["Member"],
        data(){
            return{
                ProfileImage: (this.Member?.PhotoURL ?? '/img/user-placeholder.svg'),
                viewProfile,
            }
        },
        methods:{
            getNewArticleURL(id, dealerLocationID)
            {
                return "/About/Profile/?dealerLocationID=" + dealerLocationID + "&ID=" + id;
            }
        }
    }
</script>